module.exports = __webpack_public_path__ + "img/touyaku.553a52fd.png";